// AI選考対策のTOPに載せる企業・職種リスト
export const TOPIC_COMPANIES = [
  {
    companyId: 37,
    companyName: '三菱商事',
    departmentId: 1557,
    departmentName: '総合職',
    reportType: 'intern',
  },
  {
    companyId: 38,
    companyName: '三井物産',
    departmentId: 1558,
    departmentName: '総合職',
    reportType: 'intern',
  },
  {
    companyId: 36,
    companyName: '伊藤忠商事',
    departmentId: 1554,
    departmentName: '総合職',
    reportType: 'intern',
  },
  {
    companyId: 40,
    companyName: '住友商事',
    departmentId: 2167,
    departmentName: '総合職',
    reportType: 'intern',
  },
  {
    companyId: 39,
    companyName: '丸紅',
    departmentId: 1560,
    departmentName: '総合職',
    reportType: 'intern',
  },
  {
    companyId: 1,
    companyName: 'マッキンゼー・アンド・カンパニー',
    departmentId: 1496,
    departmentName: 'コンサルタント',
    reportType: 'intern',
  },
  {
    companyId: 3,
    companyName: 'ボストンコンサルティンググループ',
    departmentId: 1498,
    departmentName: 'コンサルタント',
    reportType: 'intern',
  },
  {
    companyId: 21,
    companyName: 'ゴールドマン・サックス',
    departmentId: 2336,
    departmentName: '投資銀行部門',
    reportType: 'intern',
  },
  {
    companyId: 26,
    companyName: 'JPモルガン',
    departmentId: 1541,
    departmentName: '銀行/証券マーケット業務',
    reportType: 'intern',
  },
  {
    companyId: 43,
    companyName: 'Google',
    departmentId: 2673,
    departmentName: 'エンジニア',
    reportType: 'intern',
  },
  {
    companyId: 204,
    companyName: 'Amazon',
    departmentId: 2253,
    departmentName: 'エンジニア',
    reportType: 'intern',
  },
  {
    companyId: 52,
    companyName: 'P&Gジャパン',
    departmentId: 2095,
    departmentName: 'セールス',
    reportType: 'intern',
  },
  {
    companyId: 77,
    companyName: '三菱地所',
    departmentId: 1611,
    departmentName: '総合職',
    reportType: 'intern',
  },
  {
    companyId: 76,
    companyName: '三井不動産',
    departmentId: 1610,
    departmentName: '総合職',
    reportType: 'intern',
  },
  {
    companyId: 146,
    companyName: 'トヨタ自動車',
    departmentId: 3942,
    departmentName: '事務系',
    reportType: 'intern',
  },
  {
    companyId: 150,
    companyName: '味の素',
    departmentId: 2665,
    departmentName: '事務系',
    reportType: 'intern',
  },

  // Selection
  {
    companyId: 37,
    companyName: '三菱商事',
    departmentId: 111,
    departmentName: '総合職',
    reportType: 'selection',
  },
  {
    companyId: 38,
    companyName: '三井物産',
    departmentId: 112,
    departmentName: '総合職',
    reportType: 'selection',
  },
  {
    companyId: 36,
    companyName: '伊藤忠商事',
    departmentId: 108,
    departmentName: '総合職',
    reportType: 'selection',
  },
  {
    companyId: 40,
    companyName: '住友商事',
    departmentId: 4041,
    departmentName: '総合職',
    reportType: 'selection',
  },
  {
    companyId: 39,
    companyName: '丸紅',
    departmentId: 114,
    departmentName: '総合職',
    reportType: 'selection',
  },
  {
    companyId: 1,
    companyName: 'マッキンゼー・アンド・カンパニー',
    departmentId: 1,
    departmentName: 'ビジネスアナリスト',
    reportType: 'selection',
  },
  {
    companyId: 3,
    companyName: 'ボストンコンサルティンググループ',
    departmentId: 3,
    departmentName: 'アソシエイト',
    reportType: 'selection',
  },
  {
    companyId: 21,
    companyName: 'ゴールドマン・サックス',
    departmentId: 51,
    departmentName: '投資銀行部門',
    reportType: 'selection',
  },
  {
    companyId: 26,
    companyName: 'JPモルガン',
    departmentId: 77,
    departmentName: '投資銀行部門',
    reportType: 'selection',
  },
  {
    companyId: 43,
    companyName: 'Google',
    departmentId: 125,
    departmentName: 'エンジニア',
    reportType: 'selection',
  },
  {
    companyId: 204,
    companyName: 'Amazon',
    departmentId: 3145,
    departmentName: 'Software Development Engineer',
    reportType: 'selection',
  },
  {
    companyId: 52,
    companyName: 'P&Gジャパン',
    departmentId: 157,
    departmentName: 'Sales（営業統括）',
    reportType: 'selection',
  },
  {
    companyId: 77,
    companyName: '三菱地所',
    departmentId: 2478,
    departmentName: '総合職',
    reportType: 'selection',
  },
  {
    companyId: 76,
    companyName: '三井不動産',
    departmentId: 222,
    departmentName: '総合職',
    reportType: 'selection',
  },
  {
    companyId: 146,
    companyName: 'トヨタ自動車',
    departmentId: 388,
    departmentName: '事務系コース',
    reportType: 'selection',
  },
  {
    companyId: 150,
    companyName: '味の素',
    departmentId: 2512,
    departmentName: '事務系（グローバル型）',
    reportType: 'selection',
  },
];

export enum ReportSummaryQuestionTypeID {
  STEP = 1,
  ES_QUESTION = 2,
  ES_POINT = 3,
  WEB_TEST = 4,
  GD = 5,
  QUESTION = 6,
  OTHER = 7,
  ADVICE = 8,
  NULL = 0,
}
